import {
  COIN_WITHDRAW_ACTIVE_TAB,
  COIN_WITHDRAW_REQUEST_RESPONSE,
  COIN_WITHDRAW_REDIRECT_URL,
  COIN_WITHDRAW_CONFIRM_RESPONSE,
  CoinWithdrawDispatchType,
  COIN_WITHDRAW_PENDING_FOR_CHARGE,
} from "../../actions/coinWithdraw/CoinWithdrawType";
import {
  CoinWithdrawResponse,
  CoinWithdrawConfirmResponse,
} from "../../../models/response/coinWithdraw.response";

export interface IDefaultState {
  activeTab?: "rightSide" | "leftSide";
  redirectUrl?: string;
  coinWithdrawRequestResponse?: CoinWithdrawResponse;
  coinWithdrawConfirmResponse?: CoinWithdrawConfirmResponse;
  pendingForCharge?: boolean;
}

const defaultState: IDefaultState = {};

const CoinWithdrawReducer = (
  // eslint-disable-next-line no-restricted-globals
  state: IDefaultState = defaultState,
  action: CoinWithdrawDispatchType
): IDefaultState => {
  switch (action.type) {
    case COIN_WITHDRAW_REDIRECT_URL:
      return {
        ...state,
        redirectUrl: action.payload.redirectUrl,
      };
    case COIN_WITHDRAW_PENDING_FOR_CHARGE:
      return {
        ...state,
        pendingForCharge: action.payload.pendingForCharge,
      };
    case COIN_WITHDRAW_ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.payload.activeTab,
      };
    case COIN_WITHDRAW_CONFIRM_RESPONSE:
      return {
        ...state,
        coinWithdrawConfirmResponse: action.payload.coinWithdrawConfirmResponse,
      };
    case COIN_WITHDRAW_REQUEST_RESPONSE:
      return {
        ...state,
        coinWithdrawRequestResponse: action.payload.coinWithdrawRequestResponse,
      };
    default:
      return state;
  }
};

export default CoinWithdrawReducer;
